import fetch from './api'

// 获取用户配置
export const getUserConfig = params => {
  return fetch({
      url: `/api/menu/getUserConfig`,
      method: 'post',
      data: params
  })
}

export const saveUserConfig = params => {
  return fetch({
    url: `/api/menu/saveUserConfig`,
    method: 'post',
    data: params
  })
}





// WEBPACK FOOTER //
// ./src/api/interface-nav-config.js